'use strict';

const { window } = Function('return this')();
const { setTimeout, pubdb } = window;
const { $ } = pubdb;

var content_box = null;

var pub_by_issue_id = {}, user_by_issue_id = {}, fp_by_issue_id = {};
var pub_by_obj_id = {}, user_by_obj_id = {}, fp_by_obj_id = {};
var pub_issue_ids = [], user_issue_ids = [], fp_issue_ids = [];
var pub_obj_ids = [], user_obj_ids = [], fp_obj_ids = [];
var issue_by_id = {};

function td_button (text, callback) {
    return $('<td/>', {
        append: $('<button/>', {
            text: text,
            on: {
                click: function () {
                    content_box.empty();
                    setTimeout(callback, 0);
                    return false;
                }
            }
        })
    });
}

function display_pubs () {
    content_box.text('Diese funktion ist noch nicht implementiert.');
}

function display_users () {
    content_box.text('Diese funktion ist noch nicht implementiert.');
}

function display_fps () {
    content_box.text('Diese funktion ist noch nicht implementiert.');
}

function update_display () {
    content_box = $('<div/>', {
        css: {
            margin: '1em 0'
        }
    });
    $('#pubdb_data').empty().append($('<table/>', {
        css: {
            margin: 'auto'
        },
        append: [
            $('<td/>', {
                append: 'Anzeigen:'
            }),
            td_button('Publikationen', display_pubs),
            td_button('Benutzer', display_users),
            td_button('Forschungsprojekte', display_fps)
        ]
    })).append(content_box);
}

var IR_ID = 0;
var PUB_ID = 1, PUB_TITLE = 2;
var USER_ID = 3, USER_ACCOUNT = 4;
var FP_ID = 5, FP_TITLE = 6;
var PARAM_NAME = 7, PARAM_VALUE = 8;

function parse_data (rows) {
    for (var row_index = 0, row_count = rows.length; row_index < row_count; ++row_index) {
        var row = rows[row_index];
        var issue_id = row[IR_ID];
        var issue = issue_by_id[issue_id];
        if (!issue) {
            var issue = {
                issue_id: issue_id,
                type: '',
                params: {},
                obj_id: 0,
                obj_title: ''
            };
            var obj_id;
            if ( (obj_id = row[PUB_ID]) ) {
                issue.type = 'pub';
                issue.ref_title = row[PUB_TITLE];

                pub_by_issue_id[issue_id] = issue;
                pub_by_obj_id[obj_id] = issue;
                pub_issue_ids.push(issue_id);
                pub_obj_ids.push(obj_id);
            } else if ( (obj_id = row[USER_ID]) ) {
                issue.type = 'user';
                issue.ref_title = row[USER_ACCOUNT];

                user_by_issue_id[issue_id] = issue;
                user_by_obj_id[obj_id] = issue;
                user_issue_ids.push(issue_id);
                user_obj_ids.push(obj_id);
            } else if ( (obj_id = row[FP_ID]) ) {
                issue.type = 'fp';
                issue.ref_title = row[FP_TITLE];

                fp_by_issue_id[issue_id] = issue;
                fp_by_obj_id[obj_id] = issue;
                fp_issue_ids.push(issue_id);
                fp_obj_ids.push(obj_id);
            } else {
                continue;
            }
            issue.obj_id = obj_id;
            issue_by_id[issue_id] = issue;
        }
        var param = row[PARAM_NAME];
        if (param) {
            issue.params[param] = row[PARAM_VALUE];
        }
    }
    pub_obj_ids.sort();
    user_obj_ids.sort();
    fp_obj_ids.sort();
}

function success (data) {
    if (!data.success) {
        if ('login_required' in data.errors) {
            pubdb.relogin();
        } else if ('csrf_token' in data.errors) {
            pubdb.get_csrf_token();
        } else {
            pubdb.echo_errors(data.errors);
        }
    } else {
        parse_data(data.data);
        pubdb.display_when_ready(update_display)();
    }
}

function error (data, err, xhr) {
    pubdb.echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
}

pubdb.ajax_get(pubdb.path_root + '/issue/list/', success, pubdb.display_when_ready(error));
